const MESSAGE_CARD_TYPES = ["messageCard", "soundCard", "activityPrompt", "skipQuestion", "sentimentTest"];
export const isSurveyPrompt = (question) => {
	return question && question.type === "surveyBasicPrompt";
};

export const isConditionalAidQuestion = (question) => {
	return question && question.type === "conditionalAidSubmit";
};

export const isConditionalLogicQuestion = (question) => {
	return question && question.type === "conditionalLogic";
};

export const isHiddenConditionalQuestion = (question) => {
	return isConditionalAidQuestion(question) || isConditionalLogicQuestion(question);
};

export const isMessageCard = (question) => {
	return question && MESSAGE_CARD_TYPES.includes(question.type);
};

export const validateQuestionSubmission = (question, panelResponse) => {
	if (!question
		|| !panelResponse
		|| (!panelResponse.aid && !isMessageCard(question))
		|| isSurveyPrompt(question)
		|| (isHiddenConditionalQuestion(question) && panelResponse.aid.length <= 1)
	) {
		return false;
	}

	return true;
};

export const isDisplayableQuestion = (question) => {
	return !isHiddenConditionalQuestion(question) && !isSurveyPrompt(question);
};


// WEBPACK FOOTER //
// ./src/functions/panels.js